<template>
    <div class="product_line_content">
        <tr class="product_row">
            <td>
                <div class="container">
                    <div class="row">
                        <div class="col-md-4 col-3 art_img">
                            <a>
                                <img :src="lineData.articulo.img_verify" alt="lineData-articulo-img_verify" />
                            </a>
                        </div>
                        <div class="col-8 art_info text_desktop">
                            <a>
                                <h5>
                                    <b
                                        ><template v-if="lineData.ecologico"
                                            >ECO</template
                                        >
                                        {{
                                            lineData.articulo.especie_verify
                                                .nombre
                                        }}</b
                                    ><br />
                                    {{ lineData.articulo.nombre_verify }}
                                    <img
                                        src="/img/logos/Logo-Euro-Agricultura.png"
                                        alt="Logo ECO"
                                        style="width: 20px"
                                        v-if="lineData.ecologico"
                                        title="Producto ecológico"
                                    />
                                </h5>
                            </a>
                            <div class="iconos">
                                <img
                                    src="/img/iconos/icon_ecologico.svg"
                                    alt="Producto ecológico"
                                    title="Producto ecológico"
                                />
                                <!--                                <img v-if="Object.values(lineData.articulo.zona_actual).find(z=>z.zona=='CÁLIDA')" src="/img/iconos/icon_calida.svg" alt="icon_calida.svg" title="Producto de zona cálida">-->
                                <!--                                <img v-if="Object.values(lineData.articulo.zona_actual).find(z=>z.zona=='FRÍA')" src="/img/iconos/icon_fria.svg" alt="icon_fria.svg" title="Producto de zona fría">-->
                                <img
                                    v-if="lineData.articulo.bp_seleccion"
                                    src="/img/bp_seleccion.svg"
                                    alt="Producto recomendado por Babyplant"
                                    title="Producto recomendado por Babyplant"
                                />
                            </div>
                        </div>
                        <div class="col-9 art_info text_mobile">
                            <a>
                                <h5>{{ lineData.articulo.nombre_verify }}</h5>
                            </a>
                            <span
                                >Nº Alvéolos por bandeja:
                                {{ lineData.bandeja.unidades }}</span
                            >
                            <br />
                            <span
                                >Semillas por alvéolo:
                                {{ lineData.semilla_alveolo }}</span
                            >

                            <div class="iconos">
                                <img
                                    v-if="lineData.ecologico"
                                    src="/img/iconos/icon_ecologico.svg"
                                />
                                <!--                                <img v-if="Object.values(lineData.articulo.zona_actual).find(z=>z.zona=='CÁLIDA')" src="/img/iconos/icon_calida.svg" alt="icon_calida.svg">-->
                                <!--                                <img v-if="Object.values(lineData.articulo.zona_actual).find(z=>z.zona=='FRÍA')" src="/img/iconos/icon_fria.svg" alt="icon_fria.svg">-->
                                <img
                                    v-if="lineData.articulo.bp_seleccion"
                                    src="/img/bp_seleccion.svg"
                                />
                            </div>
                            <br />
                            <div class="info_block">
                                <span>PRECIO</span>
                                <span>{{ precioBandeja }} €</span>
                            </div>

                            <div class="row">
                                <div class="col-6 unidades">
                                    <div class="container">
                                        <div class="row">
                                            <div
                                                class="col-4 icon"
                                                @click="
                                                    lineData.unidades--;
                                                    updateLine();
                                                "
                                            >
                                                <span>-</span>
                                            </div>
                                            <div class="col-4 num">
                                                <input
                                                    v-model="lineData.unidades"
                                                    @change="updateLine()"
                                                    type="number"
                                                />
                                            </div>
                                            <div
                                                class="col-4 icon"
                                                @click="
                                                    lineData.unidades++;
                                                    updateLine();
                                                "
                                            >
                                                <span>+</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-6 semana"></div>
                            </div>

                            <div
                                class="info_block"
                                v-if="this.$root.tipo_cliente != 1"
                            >
                                <span>AHORRO</span>
                                <span>{{ ahorro | round }} €</span>
                            </div>

                            <div class="info_block">
                                <span>TOTAL</span>
                                <span>{{ total | round }} €</span>
                            </div>
                        </div>
                    </div>
                </div>
            </td>
            <td>
                <div class="container line_options_block">
                    <div class="row">
                        <div class="col-6">
                            <div class="selectores">
                                <span>Nº alvéolos por bandeja</span>
                                <select disabled>
                                    <option value="">{{
                                        lineData.bandeja.unidades
                                    }}</option>
                                </select>
                            </div>
                            <div class="selectores">
                                <span>Nº semillas por alvéolo</span>
                                <select disabled>
                                    <option value="">{{
                                        lineData.semilla_alveolo
                                    }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="selectores">
                                <span>Nº de bandejas</span>
                                <div class="container unidades">
                                    <div class="row nums">
                                        <div
                                            class="col-4 icon"
                                            @click="
                                                lineData.unidades--;
                                                updateLine();
                                            "
                                        >
                                            <span>-</span>
                                        </div>
                                        <div class="col-4 num">
                                            <input
                                                v-model="lineData.unidades"
                                                @change="updateLine()"
                                                type="number"
                                            />
                                        </div>
                                        <div
                                            class="col-4 icon"
                                            @click="
                                                lineData.unidades++;
                                                updateLine();
                                            "
                                        >
                                            <span>+</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="selectores"></div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 desgloses">
                            <span>Precio bandeja (IVA incluido)</span>
                            <span class="float-right"
                                >{{ precioBandeja }} €</span
                            >
                            <br v-if="this.$root.tipo_cliente != 1" />
                            <span v-if="this.$root.tipo_cliente != 1"
                                >Ahorro total</span
                            >
                            <span
                                class="float-right"
                                v-if="this.$root.tipo_cliente != 1"
                                >{{ ahorro | round }} €</span
                            >
                            <br />
                            <span><b>Precio total (IVA incluido)</b></span>
                            <span class="float-right"
                                ><b>{{ total | round }} €</b></span
                            >
                        </div>
                    </div>
                </div>
            </td>
            <td class="delete_block">
                <i class="fa fa-times" @click="removeCart()"></i>
            </td>
        </tr>
    </div>
</template>

<script>
import lodash from "lodash";
export default {
    props: ["line"],
    data() {
        return {
            lineData: lodash.cloneDeep(this.line),
            stock: 0,
            precioBandeja: 0
        };
    },
    mounted: function() {
        this.infoAvaiable();
    },
    watch: {
        "lineData.unidades": function(val) {
            this.recalculateTotals();
        },
        ahorro: function(val) {
            this.recalculateTotals();
        }
    },
    computed: {
        total() {
            var sub = Math.round(parseFloat(this.precioBandeja) * 100) / 100;

            return (
                ((sub * this.lineData.unidades) / 1.1 -
                    parseFloat(this.ahorro)) *
                    1.1 || 0
            );
        },
        ahorro() {
            var tasa_ahorro = 0;
            if (this.$root.tipo_cliente == 1) {
                tasa_ahorro = 0;
            } else if (this.lineData.unidades >= 12) {
                tasa_ahorro = 1;
            } else if (this.lineData.unidades >= 7) {
                tasa_ahorro = 0.66;
            } else if (this.lineData.unidades >= 3) {
                tasa_ahorro = 0.33;
            }
            return Math.round(this.lineData.unidades * tasa_ahorro * 100) / 100;
        }
    },
    methods: {
        gaRemoveFromCart() {
            const {
                id,
            } = this.lineData;
            const data = this.lineData.variety ? this.lineData.variety : this.lineData.articulo
            console.log(`data`, data)
            ga("ec:addProduct", {
                id, // Product ID (string).
                name: data.nombre, // Product name (string).
                category: data.mote_verify.nombre, // Product category (string).
                brand: "Babyplant" // Product brand (string).
                //'variant': 'gray',                  // Product variant (string).
                //'position': 2                       // Product position (number).
            });

            ga("ec:setAction", "remove");
            ga("ec:setAction", "remove_from_cart"); // Detail action.
            ga('send', 'event', 'Ecommerce', 'Remove from Cart');
        },
        infoAvaiable: function() {
            axios
                .post(this.route("account.pedidos.lineStock"), {
                    linea: this.lineData
                })
                .then(response => {
                    this.stock = response.data.stock;
                    this.precioBandeja = response.data.precioBandeja;

                    this.recalculateTotals();
                })
                .catch(e => {
                    console.log(e);
                });
        },
        removeCart: function() {
            if (confirm("¿Quieres eliminar este producto del pedido?")) {
                this.gaRemoveFromCart();
                var index = this.$vnode.key;
                this.$parent.orderData.lineas.splice(index, 1);
                this.$parent.updateTotals();
            }
        },
        updateLine: function() {
            if (this.lineData.unidades > this.stock) {
                this.lineData.unidades = this.stock;
                Vue.toasted.show("No hay más unidades disponibles.", {
                    type: "error",
                    duration: 3000
                });
            } else if (this.lineData.unidades < 1) {
                this.lineData.unidades = 1;
            }
        },
        recalculateTotals: function() {
            this.lineData.ahorro = this.ahorro;
            this.lineData.total = this.total;
            this.lineData.importe =
                parseFloat(this.precioBandeja) * this.lineData.unidades;

            var index = this.$vnode.key;
            this.$emit("updateLine", this.lineData, index);
        }
    }
};
</script>
